import { CartItem, IMenuCategory } from "../services/menu.service";

export interface IEnvironment {
    production: boolean;
    /** Receipts SQL-SoT P4c: unit stats from /v1/stats/v2 instead of statistics_v3. */
    statsV2?: boolean;
    database: any;
    primeApiUrl: string;
    pubQueueApiUrl: string;
    pubQueueApiUrlEU: string;
    adminAppUrl: string;
    posUrl: string;
    kdsUrl: string;
    netsApiUrl: string;
    pubQPosApi: string;
    publicApiUrl: string;
    posAppVersion: string;
    paymentTerminalUrl: string;
    paymentTerminalUrl_ws: string;
    paymentsApiUrl: string;
    /** Staff module API (personalliggare). Only set where the module is deployed. */
    staffApiUrl?: string;
    /** Z-rapporter -> Fortnox backend (pubq-functions fortnoxZApi). Unset = feature hidden. */
    fortnoxZApiUrl?: string | null;
    /** pubq-functions cateringApi base (group-company writes). Unset = group companies read-only. */
    cateringApiUrl?: string | null;
    /** Legacy Tastio REST base. Carried in the prod environment only; nothing reads it today. */
    baseUrl?: string;
}
export var appVersion = "3.7.48-combo.8";
export var posAppVersion = appVersion;

export class Coupon {
    code: string
    key?: string
    validFor: DeliveryPlacesEnum
    discountPercent: number
    amount?: number
}
export class DeliveryPlacesEnum {
    "0": boolean //Takeaway
    "1": boolean //Bordsservering
    "-1": boolean //Hämtas vid baren
    "-2": boolean //Utkörning
    "-3": boolean //Utkörning till leveransplats
    "-4": boolean //catering webapp
}
export class Statistics {
    name: string;
    currency: string;
    country: string;
    dayNet = 0;
    dayVat = 0;
    day = 0;
    totalAmount = 0;
    totalNet = 0;
    totalVat = 0;
    totalReceipts = 0;
    totalReceipts_web = 0;
    totalReceipts_app = 0;
    totalReceipts_pos = 0;
    totalReceipts_kiosk = 0;
    totalReceipts_catering = 0;
    totalReceipts_minimarket = 0;
    highestPurchase = 0;
    highestDiscount = 0;
    totalItemsQuantitySold = 0;
    lowestPurchase = 0;
    lowestPurchaseReceiptNo = 0;
    largestOrder = 0;
    smallestOrder = 0;
    smallestOrderReceiptNo = 0;
    medianReceipt = 0;
    totalDiscount = 0;
    products = null;
    highestPurchaseReceiptNo = ""
    highestDiscountReceiptNo = ""
    largestOrderReceiptNo = "";

    totalReceipts_app_card = new StatisticsLine();
    totalReceipts_app_swish = new StatisticsLine();
    totalReceipts_app_vipps = new StatisticsLine();
    totalReceipts_app_mobilewallet = new StatisticsLine();
    totalReceipts_app_invoice = new StatisticsLine();
    totalReceipts_app_bonuspoints = new StatisticsLine();
    totalReceipts_web_card = new StatisticsLine();
    totalReceipts_web_swish = new StatisticsLine();
    totalReceipts_web_vipps = new StatisticsLine();
    totalReceipts_kiosk_card = new StatisticsLine();
    totalReceipts_kiosk_swish = new StatisticsLine();
    totalReceipts_catering_card = new StatisticsLine();
    totalReceipts_catering_swish = new StatisticsLine();
    totalReceipts_catering_vipps = new StatisticsLine();
    totalReceipts_pos_card = new StatisticsLine();
    totalReceipts_pos_swish = new StatisticsLine();
    totalReceipts_pos_vipps = new StatisticsLine();
    totalReceipts_unknown = new StatisticsLine();

    calculation: any = {};
    constructor(statObject?: Partial<Statistics>) {
        if (statObject) {
            for (const key in statObject) {
                if (Object.prototype.hasOwnProperty.call(statObject, key)) {
                    this[key] = statObject[key];
                }
            }
        }
    }
    getChannels() {
        return Object.keys(Channel).filter((v) => isNaN(Number(v)));
    }
    getPaymentOptions() {
        return Object.keys(PaymentOption).filter((v) => isNaN(Number(v)));
    }
    getTotalsForChannel(option: Channel): StatisticsLine {
        let paymentOptions = Object.keys(PaymentOption).filter((v) => isNaN(Number(v)));
        let channel = Channel[option];
        let totals = new StatisticsLine();
        for (let index = 0; index < paymentOptions.length; index++) {
            const paymentOption = paymentOptions[index];
            let path = `totalReceipts_${channel}_${paymentOption}`;
            totals.amount += this[path] ? this[path].amount : 0;
            totals.quantity += this[path] ? this[path].quantity : 0;
        }
        return totals;
    }
    getTotalsForPaymentOption(option: PaymentOption): StatisticsLine {
        let channels = Object.keys(Channel).filter((v) => isNaN(Number(v)));
        let paymentOption = PaymentOption[option];
        let totals = new StatisticsLine();
        for (let index = 0; index < channels.length; index++) {
            const channel = channels[index];
            let path = `totalReceipts_${channel}_${paymentOption}`;
            if (!this[path])
                this[path] = new StatisticsLine();
            totals.amount += this[path].amount;
            totals.quantity += this[path].quantity;
        }
        return totals;
    }
    calculatePaymentTotals() {
        let channels = Object.keys(Channel).filter((v) => isNaN(Number(v)));
        let paymentOptions = Object.keys(PaymentOption).filter((v) => isNaN(Number(v)));
        let obj = {};
        try {

            for (let index = 0; index < channels.length; index++) {
                const channel = channels[index];
                obj[channel] = { total: this.getTotalsForChannel(Channel[channel]) };
                for (let j = 0; j < paymentOptions.length; j++) {
                    const paymentOption = paymentOptions[j];
                    let path = `totalReceipts_${channel}_${paymentOption}`;
                    if (!this[path])
                        this[path] = new StatisticsLine();
                    obj[channel][paymentOption] = this[path];
                }
            }
            for (let index = 0; index < paymentOptions.length; index++) {
                const paymentOption = paymentOptions[index];
                obj[paymentOption] = { total: this.getTotalsForPaymentOption(PaymentOption[paymentOption]) };
            }
            this.calculation = obj;
            return obj;
        } catch (error: any) {
            console.error(error.message);
        }
        return obj;
    }
    addReceiptToData_totals(receipt, unitStats: Statistics) {
        unitStats.name = receipt.salesLocation.name;
        unitStats.currency = receipt.currencyCode;
        unitStats.country = receipt.countryCode;
        unitStats.totalAmount += receipt.totalAmount;
        unitStats.totalReceipts += 1;
        for (let index = 0; index < receipt.payments.length; index++) {
            const payment = receipt.payments[index];
            switch (payment.description) {
                case "invoice in app": {
                    unitStats.totalReceipts_app_invoice.amount += payment.amount;
                    unitStats.totalReceipts_app_invoice.quantity += 1;
                    break;
                }
                case "Utnyttjad bonus": {
                    unitStats.totalReceipts_app_bonuspoints.amount += payment.amount;
                    unitStats.totalReceipts_app_bonuspoints.quantity += 1;
                    break;
                }
                case "mobile wallet in app": {
                    unitStats.totalReceipts_app_mobilewallet.amount += payment.amount;
                    unitStats.totalReceipts_app_mobilewallet.quantity += 1;
                    break;
                }
                case "Vipps": {
                    if (receipt.digitalOrder && receipt.digitalOrder.data.appType && receipt.digitalOrder.data.appType === "web") {
                        unitStats.totalReceipts_web_vipps.amount += payment.amount;
                        unitStats.totalReceipts_web_vipps.quantity += 1;
                    }
                    else if (
                        receipt.digitalOrder &&
                        receipt.digitalOrder.data.appType &&
                        (receipt.digitalOrder.data.appType === "cateringWeb" ||
                            receipt.digitalOrder.data.appType === "catering")
                    ) {
                        unitStats.totalReceipts_catering_vipps.amount += payment.amount;
                        unitStats.totalReceipts_catering_vipps.quantity += 1;
                    }
                    else {
                        unitStats.totalReceipts_app_vipps.amount += payment.amount;
                        unitStats.totalReceipts_app_vipps.quantity += 1;
                    }
                    break;
                }
                case "Swish i app": {
                    if (receipt.digitalOrder && receipt.digitalOrder.data.appType === "web") {
                        unitStats.totalReceipts_web_swish.amount += payment.amount;
                        unitStats.totalReceipts_web_swish.quantity += 1;
                    }
                    else if (receipt.digitalOrder && receipt.digitalOrder.data.appType === "kiosk") {
                        unitStats.totalReceipts_kiosk_swish.amount += payment.amount;
                        unitStats.totalReceipts_kiosk_swish.quantity += 1;
                    }
                    else if (
                        receipt.digitalOrder &&
                        receipt.digitalOrder.data.appType &&
                        (receipt.digitalOrder.data.appType === "cateringWeb" ||
                            receipt.digitalOrder.data.appType === "catering")
                    ) {
                        unitStats.totalReceipts_catering_swish.amount += payment.amount;
                        unitStats.totalReceipts_catering_swish.quantity += 1;
                    }
                    else {
                        unitStats.totalReceipts_app_swish.amount += payment.amount;
                        unitStats.totalReceipts_app_swish.quantity += 1;
                    }
                    break;
                }
                case "Kort i app": {
                    if (receipt.totalAmount < 0) {
                        unitStats.totalReceipts_app_card.amount += payment.amount;
                        unitStats.totalReceipts_app_card.quantity += -1;
                    }
                    else {
                        if (
                            receipt.digitalOrder &&
                            receipt.digitalOrder.data.appType &&
                            (receipt.digitalOrder.data.appType === "cateringWeb" ||
                                receipt.digitalOrder.data.appType === "catering")
                        ) {
                            unitStats.totalReceipts_catering_card.amount += payment.amount;
                            unitStats.totalReceipts_catering_card.quantity += 1;
                        }
                        else if (receipt.digitalOrder && receipt.digitalOrder.data.appType === "app" || !receipt.digitalOrder.data.appType) {
                            unitStats.totalReceipts_app_card.amount += payment.amount;
                            unitStats.totalReceipts_app_card.quantity += 1;
                        }
                        else {
                            unitStats.totalReceipts_web_card.amount += payment.amount;
                            unitStats.totalReceipts_web_card.quantity += 1;
                        }
                    }
                    break;
                }
                case "Kort": {
                    unitStats.totalReceipts_pos_card.amount += payment.amount;
                    unitStats.totalReceipts_pos_card.quantity += 1;
                    break;
                }
                case "Kort (Fristående terminal)": {
                    unitStats.totalReceipts_pos_card.amount += payment.amount;
                    unitStats.totalReceipts_pos_card.quantity += 1;
                    break;
                }
                case "Kort (Nets)": {
                    if (receipt.digitalOrder && receipt.digitalOrder.data.appType === "kiosk") {
                        unitStats.totalReceipts_kiosk_card.amount += payment.amount;
                        unitStats.totalReceipts_kiosk_card.quantity += 1;
                    }
                    else {
                        unitStats.totalReceipts_pos_card.amount += payment.amount;
                        unitStats.totalReceipts_pos_card.quantity += 1;
                    }
                    break;
                }
                case "Swish": {
                    unitStats.totalReceipts_pos_swish.amount += payment.amount;
                    unitStats.totalReceipts_pos_swish.quantity += 1;
                    break;
                }
                case "Vipps i kassa": {
                    unitStats.totalReceipts_pos_vipps.amount += payment.amount;
                    unitStats.totalReceipts_pos_vipps.quantity += 1;
                    break;
                }
                default: {
                    unitStats.totalReceipts_unknown.amount += payment.amount;
                    unitStats.totalReceipts_unknown.quantity += 1;
                }

            }
        }
        if (receipt.digitalOrder) {
            if (receipt.digitalOrder.data.appType) {
                if (receipt.digitalOrder.data.appType === "web")
                    unitStats.totalReceipts_web += 1;
                if (receipt.digitalOrder.data.appType === "app")
                    unitStats.totalReceipts_app += 1;
                if (receipt.digitalOrder.data.appType === "kiosk")
                    unitStats.totalReceipts_kiosk += 1;
                if (
                    receipt.digitalOrder.data.appType === "cateringWeb" ||
                    receipt.digitalOrder.data.appType === "catering"
                )
                    unitStats.totalReceipts_catering += 1;
            }
            else
                unitStats.totalReceipts_app += 1;
            if (receipt.digitalOrder.data.orderType === "minimarket")
                unitStats.totalReceipts_minimarket += 1;
        }
        else
            unitStats.totalReceipts_pos += 1;
        unitStats.totalDiscount += receipt.discountAmount;
        unitStats.totalNet += receipt.netAmount;
        unitStats.totalVat += receipt.vatAmount;
        var totalItemsQuantityOnReceipt = receipt.lines.filter(x => x.unitPrice > 0).reduce((prev, val) => prev + val.quantity, 0);
        unitStats.totalItemsQuantitySold += totalItemsQuantityOnReceipt;
        if (receipt.totalAmount <= 0)
            return unitStats;
        if (unitStats.highestPurchase < receipt.totalAmount) {
            unitStats.highestPurchase = receipt.totalAmount;
            unitStats.highestPurchaseReceiptNo = receipt.receiptNo;
        }
        if (unitStats.highestDiscount < receipt.discountAmount) {
            unitStats.highestDiscount = receipt.discountAmount;
            unitStats.highestDiscountReceiptNo = receipt.receiptNo;
        }
        if (unitStats.lowestPurchase > receipt.totalAmount) {
            unitStats.lowestPurchase = receipt.totalAmount;
            unitStats.lowestPurchaseReceiptNo = receipt.receiptNo;
        }
        if (unitStats.largestOrder < totalItemsQuantityOnReceipt) {
            unitStats.largestOrder = totalItemsQuantityOnReceipt;
            unitStats.largestOrderReceiptNo = receipt.receiptNo;
        }
        if (unitStats.smallestOrder > totalItemsQuantityOnReceipt) {
            unitStats.smallestOrder = totalItemsQuantityOnReceipt;
            unitStats.smallestOrderReceiptNo = receipt.receiptNo;
        }

        return unitStats;
    }
    addReceiptToData_products(receipt, unitStats) {
        unitStats.name = receipt.salesLocation.name;
        unitStats.currency = receipt.currencyCode;
        unitStats.country = receipt.countryCode;
        if (!unitStats.products)
            unitStats.products = {};
        for (let index = 0; index < receipt.lines.length; index++) {
            const line = receipt.lines[index];
            let lineId = line.description.toLowerCase().trim();
            if (lineId.startsWith("order") || (line.discountAmount === 0 && line.totalAmount === 0))
                continue;
            if (!unitStats.products[lineId])
                unitStats.products[lineId] = { quantity: 0, totalAmount: 0, discountAmount: 0, vatPercent: line.vatPercent, description: line.description, salesAccountNo: line.salesAccountNo, vatAccountNo: line.vatAccountNo };
            unitStats.products[lineId].quantity += line.quantity;
            unitStats.products[lineId].totalAmount += line.totalAmount;
            unitStats.products[lineId].discountAmount += line.discountAmount;
        }
        return unitStats;
    }
}
export class StatisticsLine {
    quantity = 0;
    amount = 0;
}
export enum PaymentOption {
    card,
    swish,
    vipps,
    mobilewallet,
    invoice,
    bonuspoints
}
export enum Channel {
    app,
    kiosk,
    pos,
    web,
    minimarket,
    catering

}

//Receipt model

export interface Receipt {
    id: string;
    type: 0 | 1 | 2 | 3;
    salesLocation: any;
    client: any;
    digitalOrder: { data: any };
    receiptNo: number;
    countryCode: string;
    currencyCode: string;
    languageLocalization: string;
    timestamp: number;
    dateTimeUTC: string;
    netAmount: number;
    vatAmount: number;
    roundingAmount: number;
    totalAmount: number;
    extraData: string | any;
    settlementNo: number;
    lines: Line[];
    payments: Payment[];
    unitPrice: number;
    discountAmount: number;
    vatSpecification: VatSpecification[];
    originalReceiptNo?: string;
    reason?: string;
    refundedByUserData?: any;
}

export interface Line {
    category?: any;
    description: string;
    quantity: number;
    unitPrice: number;
    discountPercent: number;
    discountAmount: number;
    netAmount: number;
    vatAmount: number;
    vatPercent: number;
    vatAccountNo: string;
    totalAmount: number;
    salesAccountNo: string;
    isService: boolean;
    selected: boolean;
    selectedQuantity: number;
    stampCardDiscountAmount?: number;
    customRefundAmount?: number;
    originalTotal?: number;
    alreadyRefunded?: number;
    remainingAmount?: number;
}

export interface Payment {
    description: string;
    amount: number;
    paymentAccountNo: string;
    extraData?: any;
    extraDataMerchant?: any;
}

export interface VatSpecification {
    vatPercent: number;
    netAmount: number;
    vatAmount: number;
    totalAmount: number;
}

export class Order {
    version: string;
    userId: string;
    userFirstName: string;
    orderCode: string;
    order: OrderContainer;
    date: number;
    tableNumber: number;
    client: { name: string; routeName: string };
    momsRegNr: string;
    deviceToken: string;
    totalItems: number;
    totalCost: number;
    totalFoodCost: number;
    totalDrinksCost: number;
    totalFoodItems: number;
    totalDrinkItems: number;
    estimatedFinishTime: Date;
    customerComment: string;
    coupon: Coupon;
    receiptNo: number;
}

export class OrderContainer {
    food: CartItem[];
    drinks: CartItem[];
}

export class Menu {
    key: string | null = null;
    name: string = '';
    isActive: boolean = false;
    categories: IMenuCategory[] = [];
    featuredProductsList: string[] = [];
    deliveryOptions = {
        eatin: { enabled: false },
        takeaway: { enabled: false },
        homeDelivery: { enabled: false },
        tableServing: { enabled: false },
        deliveryToFixedLocations: { enabled: false },
        enabled: false
    };

    timeSchedule = {
        activationTime: '00:00',
        active: false,
        weekdays: [
            { checked: false, name: 'Monday', type: 'monday' },
            { checked: false, name: 'Tuesday', type: 'tuesday' },
            { checked: false, name: 'Wednesday', type: 'wednesday' },
            { checked: false, name: 'Thursday', type: 'thursday' },
            { checked: false, name: 'Friday', type: 'friday' },
            { checked: false, name: 'Saturday', type: 'saturday' },
            { checked: false, name: 'Sunday', type: 'sunday' },
        ],
    };
    constructor(name?: string) {
        this.name = name ? name : '';
    }
}